const es = {
  common: {
    role: {
      ADMIN: "Super admin",
      TENANT_ADMIN: "Admin",
      OPERATOR: "Operador",
      PM: "Jefe de proyecto",
      MACHINE: "Máquina",
    },
    action: {
      close: "Cerrar",
      add: "Añadir",
      edit: "Editar",
      delete: "Eliminar",
      cancel: "Cancelar",
      save: "Guardar",
      print: "Imprimir",
      confirm: "Confirmar",
      select: "Seleccionar",
      assign: "Asignar",
      view: "Ver",
      yes: "Sí",
      no: "No",
      download: "Descargar",
      reset: "Restablecer",
      new: "Nuevo",
      copy: "Copiar",
    },
    table: {
      delete: "eliminar",
      deleteRows: "Eliminar %length% filas",
      add: "Nuevo",
      edit: "editar",
      close: "cerrar",
      refresh: "recargar",
      noRowsLabel: "No hay datos para mostrar",
    },
    label: {
      loading: "Cargando",
      asset: "Activo",
      name: "Nombre",
      type: "Tipo",
      createdAt: "Creado el",
      from: "Desde",
      for: "para",
      all: "Todos",
      documents: "Documentos",
      start: "Inicio",
      end: "Fin",
      releaseHere: "Suelta ",
      clickOrDrag: "Haz clic o arrastra un archivo",
      inputSearch: {
        name: "Nombre",
        createdAt: "Fecha de creación",
      },
      tag: "Tag",
      value: "Valor",
      empty: {
        assets: "No has creado ningún activo",
        documents: "No hay documentos para mostrar",
        sensors: "No hay sensores en tus activos",
        tickets: "No hay tickets para mostrar",
        artifacts: "No hay producción para mostrar",
        events: "No hay eventos para mostrar",
      },
      next: "Siguiente",
      back: "Atrás",
      yes: "Sí",
      no: "No",
    },
  },
  drawer: {
    dashboard: "Panel de control",
    assets: "Activo",
    archive: "Archivo",
    monitoring: "Monitoreo",
    users: "Usuarios",
    groups: "Grupos",
    tenants: "Empresas",
    documents: "Documentos",
    configuration: "Configuración",
    insights: "Insights",
    audits: "Registro de auditoría",
    tickets: "Tickets",
    tasks: "Tareas",
    prognosis: "Pronóstico",
    diagnosis: "Diagnóstico",
    artifacts: "Producción",
    checklist: "Checklist",
    divider: "Divisor",
    tags: "Etiquetas",
    goods: "Mercancías y residuos",
    calls: "Llamadas",
    admin: "Administración",
  },
  deleteDialog: {
    title: "Eliminar",
    text: "¿Estás seguro de que quieres proceder con la eliminación?",
    confirm: "Confirmar",
    cancel: "Cancelar",
  },
  form: {
    edit: "Editar",
    new: "Nuevo",
    reset: "Restablecer",
    save: "Guardar",
  },
  paginator: {
    rowsPerPage: "Filas",
    of: "de",
  },
  calendar: {
    date: "Fecha",
    time: "Hora",
    event: "Evento",
    allDay: "Todo el día",
    week: "Semana",
    work_week: "Semana laboral",
    day: "Día",
    month: "Mes",
    previous: "Anterior",
    next: "Siguiente",
    yesterday: "Ayer",
    tomorrow: "Mañana",
    today: "Hoy",
    agenda: "Agenda",
    noEventsInRange: "No hay eventos en este rango",
    until: "hasta",
  },
  pages: {
    login: {
      text: "Iniciar sesión a Predimain",
      username: "Nombre de usuario",
      password: "Contraseña",
      rememberMe: "Recordarme",
      login: "Iniciar sesión",
    },
    tenants: {
      clearDisk: "Limpiar disco",
      clearData: "Limpiar datos",
      clearDataDescription:
        "Esta operación eliminará todos los datos de medidas recopiladas de la empresa seleccionada. ¿Estás seguro de que deseas proceder?",
      clearDiskDescription:
        "Esta operación eliminará todos los documentos presentes en el disco de la empresa seleccionada. ¿Estás seguro de que deseas proceder?",
    },
    home: {
      addTask: {
        title: "Planifica tus actividades",
        description:
          "Programa planes de mantenimiento preventivo en los activos corporativos, define ventanas de tiempo y asigna personal técnico calificado",
      },
      addArtifact: {
        title: "Producción",
        description:
          "Planifica tus pedidos y la producción en un diagrama de Gantt. Estructura las tareas, establece dependencias temporales y controla los recursos de cada artefacto.",
      },
      addTicket: {
        title: "Gestión de tickets",
        description:
          "Gestiona los tickets de los usuarios, asigna prioridades y supervisa el progreso.",
      },
      tenants: {
        title: "Empresas",
      },
      sensors: {
        title: "Sensores",
      },
      profile: {
        welcome: "Bienvenido",
        title: "Perfil",
        today: "Hoy es",
        lastLogin: "Último acceso",
      },
      lastAudits: {
        title: "Registros",
        date: "Fecha y hora",
        user: "Nombre",
        description: "Descripción",
        has: "ha",
        action: {
          configurePermissions: "configuró permisos",
          create: "creado",
          update: "modificado",
          delete: "eliminado",
          status: "movido",
          message: "comentado",
          copy: "copiado",
          "add-task": "tarea añadida",
          "update-task": "tarea actualizada",
          upload: "documento cargado",
          tag: "modificado la etiqueta de",
          "update-checklist": "modificado la checklist de",
          "answer-checklist": "completado la checklist de",
          "clear-checklist-answer": "borrado una respuesta de la checklist de",
        },
      },
      tickets: {
        title: "Tickets",
        performance: "Performance",
        performanceNotAvailable: "Estadísticas no disponibles",
      },
      tasks: {
        title: "Tareas",
      },
      assets: {
        title: "Activos",
      },
    },
    assets: {
      title: "Activos",
      documents: "Documentos",
      tickets: "Tickets",
      tasks: "Tareas",
      notFound: "Activo no encontrado",
      noSearchResults: "Ningún activo coincide con la búsqueda",
      confirmDrop: {
        title: "Confirmar movimiento",
        text: "¿Estás seguro de que quieres mover el activo %name% dentro de %target%?",
        textNoParent: "¿Estás seguro de que quieres mover el activo %name%?",
        dropRoot: "Suelta aquí para mover a la raíz",
        confirm: "Mover",
      },
    },
    archive: {
      sensor: "Sensor",
      from: "Inicio",
      to: "Fin",
      chart: "Gráfico",
      table: "Tabla",
      date: "Fecha",
      hour: "Hora",
      value: "Valor",
      all: "Todos",
      filters: "Filtros",
    },
    prognosis: {
      asset: "Activo",
      from: "Inicio",
      to: "Fin",
      chart: "Gráfico",
      table: "Tabla",
    },
    users: {
      tab1: "Usuarios",
      tab2: "Grupos",
      editCredentials: "Credenciales",
      detail: "Detalle del usuario",
      showDetail: "Detalle",
      notFound: "Usuario no encontrado o no accesible",
      artifactTasks: "Tareas de producción",
      noArtifactTasks: "No hay tareas de producción asignadas",
      delete: {
        user: "¿Confirmar la eliminación del usuario del grupo?",
        group: "¿Confirmar la eliminación del grupo?",
      },
    },
    audits: {
      filterByType: "Filtrar por tipo",
    },
    documents: {
      search: "Buscar",
      creationDate: "Fecha",
      uploadedBy: "Subido por",
      noDocuments: "Ningún documento encontrado",
      category: "Categoría",
      resetFilter: "Limpiar filtros",
      file: "Archivo",
      addFile: "Agregar archivo",
      addFileDescription: "Los archivos se guardarán en:",
      delete: "Eliminar",
      tag: "Etiqueta",
      view: {
        folders: "Carpetas",
        table: "Lista",
      },
      open: "Abrir",
      download: "Descargar",
      goTo: {
        asset: "Ir al activo",
        task: "Ir a la tarea",
        ticket: "Ir al ticket",
        artifact: "Ir a la producción",
      },
      folders: {
        assets: "Activos",
        artifacts: "Producciones",
        other: "Varios",
      },
      rootFolder: "Carpeta raíz",
      location: "Ubicación",
      selectAll: "Seleccionar todos",
      selected: "seleccionados",
    },
    artifacts: {
      allArtifacts: "Todas las producciones",
      hour: "Por hora",
      quarterDay: "Cuarto de día",
      halfDay: "Medio día",
      day: "Día",
      week: "Semana",
      month: "Mes",
      qyear: "Cuatrimestre",
      year: "Año",
      zoomIn: "Acercar",
      zoomOut: "Alejar",
      hideTable: "Ocultar tabla",
      showTable: "Mostrar tabla",
      from: "Fecha inicio",
      to: "Fecha fin",
      assignee: "Asignado a",
      duration: "Duración",
      days: "días",
      progress: "Progreso",
      dependencies: "Dependencias",
      view: {
        gantt: "Gantt",
        table: "tabla",
      },
      editTask: {
        new: "Nueva tarea",
        edit: "Editar tarea",
        editDescription: "Editar datos de la tarea %name%",
        newDescription: "Añadir una nueva subtarea a %name%",
        name: "Nombre",
        description: "Descripción",
        assignee: "Asignado a",
        asset: "Activo",
        start: "Fecha de inicio",
        end: "Fecha de finalización",
      },
      deleteTask: {
        title: "Eliminar tarea",
        text: "¿Estás seguro de que quieres eliminar la tarea %name%?",
        confirm: "Eliminar",
      },
      changeTaskDates: {
        title: "Modificar fechas",
        text: "¿Quieres establecer la tarea %name% del %start% al %end%?",
        confirm: "Modificar",
      },
      assigned: {
        empty: "No tienes tareas asignadas.",
        fill: "Completar",
        noChecklist: "Sin checklist",
        artifactProgress: "Producción completada al %progress%%",
      },
      answer: {
        text: "Respuesta",
        select: "Selecciona",
        none: "Ninguna",
        attachment: "Adjunto",
        upload: "Adjuntar archivo",
        read: "He leído y comprendido",
        completed: "%done% de %total% pasos completados",
      },
      checklist: {
        title: "Checklist",
        description:
          "Define los pasos que el responsable de la tarea %name% deberá completar",
        empty: "Ningún paso: añade uno para empezar.",
        addStep: "Añadir paso",
        question: "Pregunta",
        readText: "Texto para leer",
        options: "Opciones",
        optionsRequired: "Añade al menos una opción",
        moveUp: "Subir",
        moveDown: "Bajar",
        type: {
          label: "Tipo",
          TEXT: "Texto libre",
          SINGLE_CHOICE: "Respuesta única",
          MULTIPLE_CHOICE: "Respuesta múltiple",
          SELECT: "Desplegable",
          FILE: "Adjunto",
          READ: "Lectura",
        },
      },
    },
    goods: {
      recycle: {
        title: "Desechar",
        step0: "Selecciona el DPP",
        step1: "Selecciona la empresa de reciclaje",
        step2: "Introduce la dirección de recogida",
        step3: "Confirma la solicitud de reciclaje",
        confirm: "Confirmar",
        confirmText:
          "Al hacer clic en confirmar, se enviará un correo electrónico con los datos ingresados a la empresa de reciclaje seleccionada",
        address: "Dirección",
      },
    },
    admin: {
      tenant: "Empresa",
      chatbot: "Chatbot",
    },
  },
  entity: {
    tenant: {
      title: "Empresa",
      name: "Nombre",
      email: "Email",
      img: "Imagen",
      primaryColor: "Color primario",
      secondaryColor: "Color secundario",
      menu: "Menú",
      users: "Usuarios",
      diskUsage: "Uso de disco",
      alertThreshold: "Alerta de umbral",
      alertSilence: "Alerta de silencio",
    },
    user: {
      title: "Usuario",
      name: "Nombre",
      surname: "Apellido",
      username: "Nombre de usuario",
      role: "Rol",
      password: "Contraseña",
      avatar: "Avatar",
      email: "Email",
      phone: "Teléfono",
      img: "Foto",
      lastLogin: "Último acceso",
    },
    group: {
      title: "grupo",
    },
    asset: {
      title: "Activo",
      type: "Tipo",
      name: "Nombre",
      description: "Descripción",
      location: "Ubicación",
      status: "Estado",
      start: "Inicio",
      end: "Fin",
      img: "Imagen",
      metadata: "Metadatos",
      assignee: "Responsable",
      sensor_scalar: "Sensor escalar",
      sensor_multivalue: "Sensor multivalor",
      building: "Edificio",
      production: "Producción",
      product: "Producto",
      machine: "Maquinaria",
      vehicle: "Vehículo",
      installationDate: "Fecha de instalación",
      estimatedEndDate: "Fecha de finalización estimada",
    },
    building: {
      title: "edificio",
    },
    machine: {
      title: "maquinaria",
    },
    sensorscalar: {
      title: "sensor escalar",
    },
    sensormultivalue: {
      title: "sensor multivalor",
    },
    production: {
      title: "producción",
    },
    vehicle: {
      title: "vehículo",
    },
    product: {
      title: "producto",
    },
    task: {
      title: "Tarea",
      name: "Nombre",
      description: "Descripción",
      assignee: "Responsable",
      asset: "Activo",
      start: "Inicio",
      end: "Fin",
      recurring: "Recurrente",
      recurrenceRule: "Regla de recurrencia",
      recurrenceEnd: "Fin de recurrencia",
      daily: "Diaria",
      weekly: "Semanal",
      monthly: "Mensual",
      tags: "Etiquetas",
    },
    ticket: {
      title: "Ticket",
      createdAt: "Creado el",
      name: "Título",
      description: "Descripción",
      assignee: "Responsable",
      asset: "Activo",
      status: "Estado",
      ip: "En progreso",
      todo: "Por hacer",
      done: "Completado",
      user: "Usuario",
      updatedAt: "Actualizado el",
      reporter: "Reportado por",
      info: "Info",
      messages: "Mensajes",
      noMessages: "No hay mensajes",
      unassigned: "Sin asignar",
      untagged: "Sin etiquetar",
      priority: {
        label: "Prioridad",
        0: "Baja",
        1: "Media",
        2: "Alta",
      },
      tags: "Etiquetas",
    },
    sensor: {
      title: "Sensor",
      name: "Nombre",
      type: "Tipo",
      color: "Color",
      thresholdMin: "Umbral mínimo",
      thresholdMax: "Umbral máximo",
      min: "Valor mínimo",
      max: "Valor máximo",
      scalar: "Escalar",
      multivalue: "Multivalor",
      columns: "Columnas",
      focus: "Enfoque",
      filters: "Filtros",
      valueFilter: {
        header: "Filtros de valores",
        add: "Añadir filtro",
        values: "Valores",
        column: "Columna",
      },
    },
    measure: {
      title: "Medida",
    },
    document: {
      title: "Documento",
    },
    diagnosis: {
      title: "Diagnóstico",
      healthIndex: "Índice de Salud",
      prevalentState: "Estado Prevalente",
      severity: "Severidad Promedio",
      timestamp: "Fecha",
    },
    prognosis: {
      title: "Pronóstico",
      rul: "RUL (Horas)",
      failureDate: "Fecha de Fallo Estimada",
      failureProbability: "Probabilidad de Fallo",
      timestamp: "Marca de tiempo",
      noData: "Sin datos",
    },
    artifact: {
      title: "Producción",
      name: "Nombre",
      description: "Descripción",
      assignee: "Responsable",
      asset: "Activo",
      start: "Inicio",
      end: "Fin",
      img: "Imagen",
      progress: "Progreso",
    },
    tag: {
      title: "Etiqueta",
      key: "Clave",
      label: "Etiqueta",
      description: "Descripción",
      color: "Color",
    },
    goods: {
      title: "Residuos",
      name: "Nombre",
      description: "Descripción",
      img: "Imagen",
      recycled: "Reciclado",
      category: "Categoría",
      category1: "Residuos no peligrosos",
      category2: "Residuos peligrosos",
      category3: "RAEE",
      category4: "Residuos sanitarios",
      category5: "Residuos de construcción y demolición",
      category6: "Residuos industriales",
      category7: "Residuos agrícolas",
    },
    call: {
      title: "Llamada",
      caller: "Llamante",
      callee: "Llamado",
      startedAt: "Inicio",
      endedAt: "Fin",
      duration: "Duración",
      outcome: {
        label: "Resultado",
        all: "Todos",
        completed: "Completada",
        missed: "Perdida",
        rejected: "Rechazada",
      },
      summary: "Resumen",
    },
  },
  userActions: {
    settings: "Configuración",
    logout: "Cerrar sesión",
    light: "Claro",
    dark: "Oscuro",
    system: "Sistema",
    language: "Idioma",
    theme: "Tema",
    logoutDialog: {
      title: "Confirmar cierre de sesión",
      text: "¿Estás seguro de que quieres terminar la sesión actual y cerrar sesión?",
      exit: "Cerrar sesión",
      cancel: "Cancelar",
    },
    search: {
      title: "Buscar",
      placeholder: "Buscar...",
      button: "Buscar",
      type: {
        asset: "Activo",
        document: "Documento",
        task: "Tarea",
        ticket: "Ticket",
        artifact: "Producción",
      },
    },
  },
  notifications: {
    title: "Notificaciones",
    empty: "No hay notificaciones",
    "task-created": "Nueva tarea",
    "task-updated": "Tarea actualizada",
    "ticket-created": "Nuevo ticket",
    "ticket-message": "Nuevo mensaje",
    "ticket-updated": "Ticket actualizado",
    "ticket-status-updated": "Ticket movido",
    prognosis: "Nuevo pronóstico",
    diagnosis: "Nuevo diagnóstico",
  },
  permissions: {
    title: "Configurar permisos",
    description:
      "Selecciona un elemento del catálogo de datos y configura los permisos para asociar con la selección",
    table: {
      title: "Configurar permisos",
      groupUser: "Grupo/Usuario",
      canView: "Puede ver",
      canEdit: "Puede editar",
      canDelete: "Puede eliminar",
    },
  },
  chatbot: {
    title: "Asistente",
    open: "Abrir el chat",
    close: "Cerrar el chat",
    new: "Nueva conversación",
    empty: "Pregunta algo al asistente",
    placeholder: "Escribe un mensaje",
    send: "Enviar",
    stop: "Detener",
    requestCancelled: "Solicitud cancelada.",
    provider: "Proveedor",
    model: "Modelo",
    assistant: "Asistente",
    noProviders: "Ningún modelo disponible",
    configure: "Configurar el chatbot",
    notConfiguredAdmin: "Configura la clave y el modelo en la página Chatbot",
    notConfigured: "El chatbot no está configurado, contacta al administrador.",
    selectTenant: "Selecciona una empresa para usar el chatbot.",
    error: {
      default: "No se puede completar la solicitud",
      unavailable: "Proveedor no configurado: falta la clave",
      rejected: "El proveedor ha rechazado la clave",
      rateLimit: "Demasiadas solicitudes, inténtalo de nuevo en un momento",
      selectTenant: "Selecciona un tenant para usar el chatbot.",
      disabled: "El chatbot está desactivado para este tenant.",
    },
    suggestions: {
      title: "Pendientes",
      checklist: {
        one: "tarea con checklist por completar",
        other: "tareas con checklist por completar",
        prompt: "Completemos la checklist",
      },
      myTickets: {
        one: "ticket asignado a ti",
        other: "tickets asignados a ti",
        prompt: "¿Qué tickets tengo asignados?",
      },
    },
    choices: {
      send: "Enviar",
    },
    action: {
      confirm: "Confirmar",
      cancel: "Cancelar",
      done: "Ejecutada",
      failed: "No ejecutada",
      cancelled: "Cancelada",
      superseded: "Sustituida por una propuesta más reciente",
      cancelledMessage: "Acción cancelada",
    },
    history: {
      open: "Historial de conversaciones",
      title: "Historial",
      back: "Volver al chat",
      empty: "No hay conversaciones guardadas",
      rename: "Renombrar conversación",
      renameField: "Nuevo título",
      renameSave: "Guardar título",
      renameCancel: "Cancelar",
      delete: "Eliminar conversación",
      deleteConfirm: {
        title: "¿Eliminar esta conversación?",
        confirm: "Eliminar",
        cancel: "Cancelar",
      },
    },
    settings: {
      title: "Ajustes del chatbot",
      enabled: "Chatbot activo",
      apiKey: "Clave API",
      showKey: "Mostrar clave",
      hideKey: "Ocultar clave",
      models: {
        loading: "Cargando modelos",
        missingKey: "Guarda primero la clave de este proveedor.",
        error: "No se pueden cargar los modelos",
      },
      documents: {
        title: "Documentos",
        hint: "El chatbot usa los documentos cargados en PrediMain y se actualiza solo.",
        reindex: "Reindexar ahora",
        indexedOne: "indexado",
        indexedMany: "indexados",
        skippedOne: "omitido",
        skippedMany: "omitidos",
        failedOne: "fallido",
        failedMany: "fallidos",
        embedding: "El servicio de embedding no está configurado",
      },
    },
  },
  error: {
    0: "Se ha producido un error",
    101: "El contenido solicitado no existe",
    105: "Acción no permitida",
    401: "Fallo en la autenticación",
    500: "No se puede completar la operación",
    forbidden: {
      title: "Acceso denegado",
      text: "No tienes permiso para ver este recurso.",
      back: "Volver al inicio",
    },
    sessionExpired: "Sesión expirada",
    validation: {
      required: "Campo obligatorio",
      duplicate: "El valor ya existe",
      endDateAfterStartDate:
        "La fecha de finalización debe ser posterior a la fecha de inicio",
      type: {
        number: "El campo debe ser un número",
      },
    },
  },
};

export default es;
